/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import BulmaButton from 'react-bulma-components/lib/components/button';
import BulmaContainer from 'react-bulma-components/lib/components/container';
import BulmaSection from 'react-bulma-components/lib/components/section';

import { css } from '@emotion/core';
import { Heading, LazyLink, LazyImage } from '../atoms';

import {
  styledHeading,
  styledBrandLogo,
  styledSubHeading,
  styledButtonContainer,
  styledCenterHeroText,
  styledHeroTextSection,
  styledHeroTextFullscreen,
} from './HeroTextBrandedStyles';

const renderButton = (link, text, atts) => (
  <LazyLink url={link.url} {...atts}>
    {text.text}
  </LazyLink>
);

const renderHeading = (text, atts) => <Heading {...atts}>{text.text}</Heading>;

const HeroTextBranded = ({ input }) => {
  const {
    fullscreen,
    large_text,
    text_color,
    background_color,
    background_image,
    brand_logo,
    heading,
    subheading,
    display_primary_cta,
    primary_cta_color,
    primary_cta_link,
    primary_cta_text,
    display_secondary_cta,
    secondary_cta_link,
    secondary_cta_text,
    text_alignment,
  } = input.primary;

  return (
    <BulmaSection
      css={css`
        ${styledHeroTextSection}
        background-color: ${background_color};
        ${background_image ? `background-image: url(${background_image.url});` : null};
        ${text_alignment === 'center' ? 'text-align: center;' : 'text-align: left;'}
        ${fullscreen && styledHeroTextFullscreen}
      `}
    >
      <BulmaContainer css={text_alignment === 'center' ? styledCenterHeroText : null}>
        {brand_logo && brand_logo.url && <LazyImage css={styledBrandLogo} src={brand_logo && brand_logo.url} />}
        {heading && heading[0]
          ? renderHeading(heading[0], {
              id: 'herotext-heading',
              className: `${text_color === 'light' ? 'h1 white' : 'h1 darkblue'} ${large_text ? 'hero-title' : ''}`,
              css: styledHeading,
              style: { margin: text_alignment === 'left' ? '0' : '' },
            })
          : null}
        {subheading && subheading[0]
          ? renderHeading(subheading[0], {
              id: 'herotext-subheading',
              className: `${text_color === 'light' ? 'large white' : 'large darkblue'}`,
              renderAs: 'p',
              subtitle: true,
              css: styledSubHeading,
              style: { margin: text_alignment === 'left' ? '0' : '' },
            })
          : null}
        {display_primary_cta || display_secondary_cta ? (
          <BulmaButton.Group
            id="herotext-buttons"
            style={text_alignment === 'center' ? { display: 'flex', justifyContent: 'center' } : null}
            css={styledButtonContainer}
          >
            {display_primary_cta && primary_cta_text && primary_cta_link
              ? renderButton(primary_cta_link, primary_cta_text[0], { className: 'button-link is-primary' })
              : null}
            {display_secondary_cta && secondary_cta_text && secondary_cta_link
              ? renderButton(secondary_cta_link, secondary_cta_text[0], {
                  className: 'button-link is-white is-outlined',
                })
              : null}
          </BulmaButton.Group>
        ) : null}
      </BulmaContainer>
    </BulmaSection>
  );
};

export default HeroTextBranded;

HeroTextBranded.propTypes = {
  input: PropTypes.object.isRequired,
};
